import {Box, Link, styled, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AccessTimeRounded, CalendarTodayRounded} from "@mui/icons-material";
import Carousel from 'react-material-ui-carousel'

const Container = styled(Box)(() => ({
  backgroundSize: 'cover',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '80px 20px',
  position: 'relative',
}));

const StyledBox = styled(Box)(({theme}) => ({
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
  },
}));

const ImageContainer = styled(Box)(({theme}) => ({
  maxHeight: 460,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    minWidth: 420,
  },
}));

const Image = styled('img')(() => ({
  maxWidth: '100%',
  maxHeight: 'inherit',
  borderRadius: '8px',
  minHeight: 460,
  objectFit: 'cover',
}));

const Title = styled(Typography)(() => ({
  fontWeight: 600,
  textTransform: 'uppercase',
}));

const EventSection = () => {
  const {t} = useTranslation();

  return (
    <>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Carousel
                sx={{ width: 328, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/weihnachtsplaetzchen-2026-1.jpg" alt="event_image"/>
              <Image src="/img/weihnachtsplaetzchen-2026-2.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event13.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event13.time')}</Title>
            </Box>
            <Typography variant="body" sx={{whiteSpace: 'pre-line'}}>{t('event13.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Carousel
                sx={{ width: 328, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/schuhkarton-2026-1.jpg" alt="event_image"/>
              <Image src="/img/schuhkarton-2026-2.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event11.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event11.time')}</Title>
            </Box>
            <Typography variant="body" sx={{whiteSpace: 'pre-line'}}>{t('event11.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Carousel
                sx={{ width: 328, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/taufe-2026-1.jpg" alt="event_image"/>
              <Image src="/img/taufe-2026-2.jpg" alt="event_image"/>
              <Image src="/img/taufe-2026-3.jpg" alt="event_image"/>
              <Image src="/img/taufe-2026-4.jpg" alt="event_image"/>
              <Image src="/img/taufe-2026-5.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event12.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event12.time')}</Title>
            </Box>
            <Typography variant="body" sx={{whiteSpace: 'pre-line'}}>{t('event12.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Image src="/img/youth-camp-2026.png" alt="event_image"/>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event10.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event10.time')}</Title>
            </Box>
            <Typography variant="body" sx={{whiteSpace: 'pre-line'}}>{t('event10.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Image src="/img/photo_2026-04-3009.08.59.jpg" alt="event_image"/>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event9.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event9.time')}</Title>
            </Box>
            <Typography variant="body" sx={{whiteSpace: 'pre-line'}}>{t('event9.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Carousel
                sx={{ width: 328, height: '100%'}}
                next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
                prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/photo_5377683742387801561_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5377683742387801562_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5377683742387801560_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5377683742387801559_y.jpg" alt="event_image"/>
              <Image src="/img/photo_5377683742387801557_y.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event8.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event8.time')}</Title>
            </Box>
            <Typography variant="body">{t('event8.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
      <Container>
        <StyledBox width={1200} display="flex">
          <ImageContainer>
            <Carousel
              sx={{ width: 328, height: '100%'}}
              next={(next, active) => console.log(`we left ${active}, and are now at ${next}`)}
              prev={(prev, active) => console.log(`we left ${active}, and are now at ${prev}`)}
            >
              <Image src="/img/photo_5278514175883808145_y.jpg" alt="event_image"/>
            </Carousel>
          </ImageContainer>
          <Box sx={{p: 4, width: '100%'}}>
            <Box display="flex" alignItems="center" gap={1}>
              <CalendarTodayRounded/>
              <Title variant="subtitle1">{t('event5.title')}</Title>
            </Box>
            <Box sx={{mb: 4, mt: 1, color: '#9a9a9a'}} display="flex" alignItems="center" gap={1}>
              <AccessTimeRounded/>
              <Title variant="caption">{t('event5.time')}</Title>
            </Box>
            <Typography variant="h5">{t('event5.description')}</Typography>
          </Box>
        </StyledBox>
      </Container>
    </>
  );
};

export default EventSection;
